export type ContributionStatus = "REJECTED" | "TO_VALIDATE" | "PENDING" | "COMPLETED";

export const STATUSES: ContributionStatus[] = ["COMPLETED", "PENDING"];